import { ThemeIcon } from '@mantine/core';
import { IconMessage, IconPhoto } from '@tabler/icons-react';
import dayjs from 'dayjs';

import styles from './LinkedMemoryItem.module.scss';
import { Props } from './LinkedMemoryItem.types';

// A wall item: a memory album, or an ordinary message in the "Messages" group.
const LinkedMemoryItem = ({ item, onClick }: Props) => {
  const isMemory = item.metadata?.kind === 'memory';
  const date = (item.metadata?.takenAt ?? item.metadata?.createdAt) as string | undefined;
  const details = [item.subtitle, date ? dayjs(date).format('DD/MM/YYYY') : undefined]
    .filter(Boolean)
    .join(' · ');

  return (
    <div className={styles.container} onClick={onClick}>
      <ThemeIcon variant="light" color={isMemory ? 'grape' : 'gray'} size="lg" radius="md">
        {isMemory ? <IconPhoto size={18} /> : <IconMessage size={18} />}
      </ThemeIcon>
      <div className={styles.content}>
        <span className={styles.title}>{item.title}</span>
        {details && <span className={styles.subtitle}>{details}</span>}
      </div>
    </div>
  );
};

export default LinkedMemoryItem;
